import React, { useState, useEffect } from "react";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import IconMdi from "@mdi/react";
import { mdiPencilCircle, mdiDelete } from "@mdi/js";
import axios from "axios";
import { Modal } from "antd";
import { Icon } from "@iconify/react";

const JobPermission = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [jobGroup, setJobPermission] = useState([]);
  const columns = [
    {
      title: "",
    },
    {
      title: "ชื่อกรุ๊ปงาน",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // deleteData(id);
      },
      width: "fit-content",
    });
  }

  const getData = () => {
    // axios.get(`/job-groups`).then((res) => {
    //   console.log("res.data.data =>", res.data.data);
    //   setJobPermission(res.data.data);
    // });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <HeaderBar title="JOB PERMISSION" />
      <div style={{ padding: "10px 40px" }}>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {jobGroup.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="50%">{item.name}</TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() =>
                      history.push(`/setting/job/group/${item._id}/create`)
                    }
                  >
                    <IconMdi path={mdiPencilCircle} size="30" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn
                  width="5%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.name);
                  }}
                >
                  <IconMdi path={mdiDelete} size="25" color="#FF6760"></IconMdi>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default JobPermission;
